import { ChakraProvider } from '@chakra-ui/react';

import theme from '@view/theme';

import { PortalProvider } from '@molecules/BEPortal';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <ChakraProvider theme={theme}>
        <BrowserRouter basename={process.env.PUBLIC_URL || ''}>
          <PortalProvider>{children}</PortalProvider>
        </BrowserRouter>
      </ChakraProvider>
    </>
  );
};
